export const IDEA_CATEGORIES = [
    { value: 'contabilita', label: 'Contabilità', color: '#3b82f6' },
    { value: 'marketing', label: 'Marketing', color: '#10b981' },
    { value: 'hr', label: 'Risorse Umane', color: '#f59e0b' },
    { value: 'operations', label: 'Operations', color: '#ef4444' },
    { value: 'it', label: 'IT', color: '#8b5cf6' },
    { value: 'vendite', label: 'Vendite', color: '#ec4899' },
    { value: 'customer-service', label: 'Servizio Clienti', color: '#06b6d4' },
    { value: 'altro', label: 'Altro', color: '#6b7280' }
];

export const getCategoryColor = (categoryValue) => {
    const category = IDEA_CATEGORIES.find(c => c.value === categoryValue);
    return category?.color || '#6b7280';
};

export const getCategoryLabel = (categoryValue) => {
    const category = IDEA_CATEGORIES.find(c => c.value === categoryValue);
    return category?.label || categoryValue;
};
